export enum ChannelActionType {
  NEW = 'new',
  FAVORITE = 'favorite',
  RECIPIENT = 'recipient',
}
